import { createContext, ReactNode, useContext, useState } from 'react'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'

type AttributeLoadingContextType = {
  loading: Record<IntegrationType, boolean>
  setLoading: (type: IntegrationType, value: boolean) => void
}

const AttributeLoadingContext = createContext<AttributeLoadingContextType | undefined>(undefined)

export const AttributeLoadingProvider = ({children}: {children: ReactNode}) => {
  const [loading, setLoadingState] = useState<Record<IntegrationType, boolean>>({
    [IntegrationType.Ozon]: false,
    [IntegrationType.Wildberries]: false,
    [IntegrationType.YandexMarket]: false,
    [IntegrationType.MoySklad]: false
  })

  const setLoading = (type: IntegrationType, value: boolean) => {
    setLoadingState((prev) => ({...prev, [type]: value}))
  }

  return (
    <AttributeLoadingContext.Provider value={{loading, setLoading}}>
      {children}
    </AttributeLoadingContext.Provider>
  )
}

export const useAttributeLoading = () => {
  const context = useContext(AttributeLoadingContext)
  if (!context) {
    throw new Error('useAttributeLoading must be used within AttributeLoadingProvider')
  }
  return context
}
